import React, {Component} from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";
import Modal from '@material-ui/core/Modal';
import Button from "@material-ui/core/Button";
import Grow from '@material-ui/core/Grow';
import modalStyle from '../style'
import {getTranslation} from "../../../helpers/get-translation";


const styles = theme =>  (Object.assign({}, modalStyle, {
	modalBody: {
		backgroundColor: theme.palette.background.paper,
		boxShadow: theme.shadows[5]
	},
	header:{
		fontSize: '30px',
		color: '#1c9ddd',
	},
	levelText: {
		fontSize: '23px',
		color: '#1c9ddd',
	},
	button:{
		display: 'block',
		margin: 'auto',
		marginTop: '20px',
		backgroundColor: "#1c9ddd",
		color: 'white',
		"&:hover": {
			backgroundColor: "#006da2"
		}
	},

}));

class UnlockExtraLevelModal extends Component {

	render(){
		const { modal,
			classes,
			removeModalWindow } = this.props;

		return (
			<Modal
				className={classes.modal}
				open={true}
				onClose={() => removeModalWindow()}
			>
				<Grow in={true}>
					<div>
						<img className={classes.closeButton} src={getTranslation("image_modal_close_button")} onClick={() => removeModalWindow()}/>
						<div className={`${classes.modalBody} ${classes.defaultBody}`}>
							<div className={classes.header}>{modal.titleText}</div>

							<img className={classes.image} src={modal.levelIcon} />

							<div className={classes.levelText}>{getTranslation("modal_congratulation")}</div>
							<div>{modal.bodyText}</div>

							<Button
								variant="contained"
								className={`${classes.button}`}
								onClick={() => removeModalWindow()}
							>
								Ok
							</Button>
						</div>
					</div>
				</Grow>
			</Modal>
		)


	}
}



UnlockExtraLevelModal.propTypes = {
	modal: PropTypes.object.isRequired,

	classes: PropTypes.shape({
		modal: PropTypes.string.isRequired,
		modalBody: PropTypes.string.isRequired,
		button: PropTypes.string.isRequired,
	}).isRequired,

	removeModalWindow: PropTypes.func.isRequired,
}
export default withStyles(styles)(UnlockExtraLevelModal);
